import { createGamingModuleStore } from './gaming-module-factory'

export const useFactorioStore = createGamingModuleStore('factorio', 34197)
